import { tt } from '@agos/shared'

/**
 * Who stores the QR payment settings - `FRONTEND.md` §9.758, `BACKEND.md` §10A.413.
 *
 * <p>`PATCH /settings/qr-payment` holds the IBAN customers pay into and the Tatra client id and secret, so §10A.413
 * keeps it with the main administrator - one of the 27 handlers that stay, with the bank's own consent and disconnect.
 * The screen offered its save to everybody the route admits (`qr_payment` and `delivery_settings`), and the server
 * refused it; `qr_payment`'s own description on the roles screen already says *Bankový účet, na ktorý zákazníci
 * platia, uloží iba hlavný administrátor*. A role, not a right, because no right may open it.
 */
export const QR_SETTINGS_ROLE = 'main_admin'

export function storesQrSettings(systemRole: string | undefined): boolean {
  return systemRole === QR_SETTINGS_ROLE
}

/** Said above the settings to anybody else - the form stays readable, the preview usable. */
export function qrSettingsNote(): string {
  return tt('Bankový účet, na ktorý zákazníci platia, a prístup k TatraPay uloží len hlavný administrátor.')
}
